import { render } from "./Servicio.vue?vue&type=template&id=2e684c29"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"
script.render = render

export default script